import React from 'react'
import map from 'lodash/map'
import ButtonParameter from '@SiteContainers/SetupProjectPopup/ButtonParameter'
import Termbase from '@Images/finetune_parameters_termbase.svg'
import AutoTone from '@Images/finetune_parameters_auto_tone.svg'
import FormalTone from '@Images/finetune_parameters_formal_tone.svg'
import InformalTone from '@Images/finetune_parameters_informal_tone.svg'

import {
  IProjectVersionSettingsParameter,
} from '@SiteModules/ProjectVersionSettings/types'

import {
  ITermbase,
} from '@SiteModules/Termbase/types'

import './ParametersTts.scss'

interface ParametersTtsProps {
  readonly termbaseOption: string | null
  readonly translationToneOption: string | null
  readonly termbases: ITermbase[]
  readonly willTranslate: boolean
  setTermbaseOption(newTermbaseOption: string | null): void
  setTranslationToneOption(newTranslationToneOption: string | null): void
}

const ParametersTts: React.FC<ParametersTtsProps> = (props) => {
  const {
    termbaseOption,
    translationToneOption,
    setTermbaseOption,
    setTranslationToneOption,
    termbases,
    willTranslate,
  } = props

  const termbaseParameter: IProjectVersionSettingsParameter = {
    name: 'Term base',
    icon: <Termbase />,
    searchPlaceholder: 'Select term base...',
    options: map(termbases, termbase => ({ name: termbase.attributes.name })),
    nullOption: {
      name: 'No term base',
    },
    selectedOptionName: termbaseOption,
    setSelectedOption: setTermbaseOption,
    shouldHide: false,
    tooltipText: 'Use a glossary of predefined pronunciation to ensure consistency across your project.'
  }

  const translationToneParameter: IProjectVersionSettingsParameter = {
    name: 'Translation tone',
    options: [{
      name: 'Auto tone',
      icon: <AutoTone />
    }, {
      name: 'Formal tone',
      icon: <FormalTone />
    }, {
      name: 'Informal tone',
      icon: <InformalTone />
    }],
    selectedOptionName: translationToneOption,
    setSelectedOption: setTranslationToneOption,
    shouldHide: !willTranslate,
    tooltipText: 'Select the translation tone style: formal for professional content or informal for casual or conversational content.'
  }

  return (
    <div className="ParametersTts">
      <div className="SetupProjectPopupTts__section-header">
        Parameters
      </div>
      <div className="ParametersTts__buttons">
        <ButtonParameter
          parameter={termbaseParameter}
          classNameOfContainerToMakeUnscrollable="SetupProjectPopupTts"
        />
        {!translationToneParameter.shouldHide && (
          <ButtonParameter
            parameter={translationToneParameter}
            classNameOfContainerToMakeUnscrollable="SetupProjectPopupTts"
          />
        )}
      </div>
    </div>
  )
}

export default ParametersTts
